import type { CustomBoolean } from 'constants/enums'
import type { RequestOVsByFilters } from 'services/manage_ov/interface'

export type InfosOvInterface = {
  return_chav?: string
  nr_pedi_rasc?: string
  cd_empr?: string
  cd_orgn_vend?: string
  cd_canl_dstb?: string
  cd_seto_atvd?: string
  cd_escr_vend?: string
  cd_equi_vend?: string
  cd_regi_vend?: string
  cd_tipo_orde?: string
  cd_cond_pgto?: string
  nr_dias_adic?: string
  nr_pedi_clie?: string
  nr_pedi_cpra?: string
  cd_clie?: string
  cd_clie_entr?: string
  ds_text_item_mto?: string
  fl_matr_fora_linh?: string
  fl_mto_prep?: CustomBoolean
  fl_dsct_matr?: string
  fl_prmt_desd?: string
  ds_item_pedi_rasc?: object[]
  cd_usua_alte?: string
  fl_orde_tele_vend?: string
}

export const defaultRequestOvValues: RequestOVsByFilters = {
  codigoCor: [],
  codigosCentros: [],
  codigosMateriais: [],
  codigosStatusEstoque: [],
  codigosStatusOrdemVenda: [],
  codigoTipoOrdem: '',
  codigoZona: [],
  dataFinal: null,
  dataInicial: null,
  documentoFatura: [],
  escritorioVenda: [],
  materialMTO: null,
  numeroNotaFiscal: [],
  numeroOrdemVenda: [],
  numeroOrdemVendaSAP: [],
  numeroPedidoCliente: [],
  numeroPedidoRascunho: [],
  searchBox: '',
  tiposMateriais: null,
}
